<!-- header.component.html -->
<header class="header">
  <div class="header-content">
    <div class="logo-container">
      <a href="#" class="logo">
        <img src="{{ 'HEADER.LOGO' | translate }}" class="logo-img" />
      </a>
    </div>

    <div class="header-actions">
      <button class="btn btn-light search-btn" (click)="onSearchClick()">
        <i class="fas fa-search"></i> {{ 'HEADER.SEARCH' | translate }}
      </button>
      <div class="dropdown language-dropdown">
        <button class="btn btn-light dropdown-toggle" type="button" id="languageDropdown" data-bs-toggle="dropdown" aria-expanded="false">
          {{ 'HEADER.LANGUAGE' | translate }}
        </button>
        <ul class="dropdown-menu" aria-labelledby="languageDropdown">
          <li *ngFor="let lang of availableLanguages">
            <a class="dropdown-item" href="#"
               [class.active]="isCurrentLanguage(lang.code)"
               (click)="onLanguageSelect(lang.code, $event)">
              {{ lang.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
